import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TgRackModule } from '@trademe/tangram';
import { PropertyPromoteSectionModule } from '../../../sections/property-default-sections/property-promote-section/property-promote-section.module';
import { PropertyPromotePageComponent } from './property-promote-page.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgRackModule,
        PropertyPromoteSectionModule
    ],
    declarations: [PropertyPromotePageComponent],
    exports: [PropertyPromotePageComponent]
})
export class PropertyPromotePageModule {}
